import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'product_tile-middle-click';

/**
 * An event for when a product tile is middle clicked.
Parameters: context (deprecated, see below), requestId, productToken, promotedBy

ImpressionId: BE-generated product impression id
screenContext: ProductTileScreen
containerContext: ProductTileScreenContainer
token: screen specific token e.g. query
 */
export function trackProductTileMiddleClick(
  context_string: string,
  requestId_string2: string,
  productToken: string,
  promotedBy_string3: string,
  impressionId_string4: string,
  screenContext_string5: string = '',
  containerContext_string6: string = '',
  Token_string7: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      context_string,
      requestId_string2,
      productToken,
      promotedBy_string3,
      impressionId_string4,
      screenContext_string5,
      containerContext_string6,
      Token_string7,
    },
  });
}
